<app-section-quick-actions section="item" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Item previews</h1>
</header>

<app-item-grid-layout [items]="items" [itemTemplate]="previewTpl" [initialCategory]="initialCategory"/>
<ng-template #previewTpl let-item>
  <a class="atmos-item-preview__item atmos-tile"
     [routerLink]="['/item', item.guid]"
     [skyTooltip]="item.name" [attr.aria-label]="item.name">
    <img class="atmos-item-preview__img atmos-img-box" [src]="item.previewUrl" loading="lazy" draggable="false"/>
    <app-icon class="atmos-item-preview__icon"
              [src]="item.icon || '/assets/icons/question.webp'"
              width="64px" height="64px"
              [lazy]="true" [draggable]="false">
    </app-icon>
    <app-item-subicons [item]="item" [icons]="SUBICONS_ALL" [size]="24"/>
  </a>
</ng-template>
